function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  var t = {};

  function n(i) {
    if (t[i]) return t[i].exports;
    var r = t[i] = {
      i: i,
      l: !1,
      exports: {}
    };
    return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, i) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: i
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var i = Object.create(null);
    if (n.r(i), Object.defineProperty(i, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      n.d(i, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return i;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 298);
}({
  0: function _(e, t) {
    e.exports = require("react");
  },
  1: function _(e, t, n) {
    e.exports = n(53)();
  },
  125: function _(e, t) {
    e.exports = require("vega-lib");
  },
  298: function _(e, t, n) {
    "use strict";

    n.r(t);
    var i = n(0),
        r = n.n(i),
        a = n(1),
        o = n.n(a),
        u = n(125);

    function s(e) {
      return null !== e && void 0 !== e;
    }

    function c(e) {
      return !!e && "[object Function]" === {}.toString.call(e);
    }

    var f = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var i in n) {
          Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
        }
      }

      return e;
    },
        l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
        }
      }

      return function (t, n, i) {
        return n && e(t.prototype, n), i && e(t, i), t;
      };
    }();

    !function (e, t, n) {
      if ("undefined" != typeof window) {
        var i = n || window,
            r = !1;
        i.addEventListener(e, function () {
          r || (r = !0, requestAnimationFrame(function () {
            i.dispatchEvent(new CustomEvent(t)), r = !1;
          }));
        });
      }
    }("resize", "optimizedResize");

    var p = {
      className: o.a.string,
      style: o.a.object,
      spec: o.a.object.isRequired,
      logLevel: o.a.number,
      width: o.a.number,
      height: o.a.number,
      tooltip: o.a.func,
      background: o.a.string,
      padding: o.a.object,
      renderer: o.a.string,
      enableHover: o.a.bool,
      data: o.a.object,
      onNewView: o.a.func,
      onParseError: o.a.func,
      theme: o.a.object
    },
        h = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, r.a.Component), l(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props.spec;
          this.createView(e), this.view && this.setListeners();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          var n = this,
              i = this.props,
              r = this.props.spec;
          if (r !== e.spec) this.clearView(), this.createView(r);else if (this.view) {
            var a = !1;
            ["width", "height", "renderer", "logLevel", "background"].filter(function (t) {
              return i[t] !== e[t];
            }).forEach(function (e) {
              n.view[e](i[e]), a = !0;
            }), t.isSamePadding(i.padding, e.padding) || (this.view.padding(i.padding || r.padding), a = !0), r.data && i.data && r.data.forEach(function (r) {
              var o = e.data[r.name],
                  u = i.data[r.name];
              t.isSameData(o, u) || (n.updateData(r.name, u), a = !0);
            }), i.enableHover !== e.enableHover && (a = !0), a && (i.enableHover && this.view.hover(), this.view.run());
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.clearView();
        }
      }, {
        key: "setListeners",
        value: function value() {
          if ("fit" === (this.props.spec.autosize || {}).type) {
            if ("undefined" == typeof window) return;
            window.addEventListener("optimizedResize", this.updateViewDimensions.bind(this));
          }
        }
      }, {
        key: "removeListeners",
        value: function value() {
          if ("fit" === (this.props.spec.autosize || {}).type) {
            if ("undefined" == typeof window) return;
            window.removeEventListener("optimizedResize", this.updateViewDimensions.bind(this));
          }
        }
      }, {
        key: "calculateSize",
        value: function value() {
          return this.view ? this.view.container().getBoundingClientRect() : {};
        }
      }, {
        key: "updateViewDimensions",
        value: function value() {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];

          if (this.view) {
            var t = this.props,
                n = this.view,
                i = this.calculateSize(),
                r = i.width,
                a = i.height;
            t.width || n.width(r), t.height || n.height(a), e && n.run();
          }
        }
      }, {
        key: "createView",
        value: function value(e) {
          var n = this,
              i = f({}, e);

          if (i) {
            var r = this.props;

            try {
              var a = Object(u.parse)(i, r.theme),
                  o = new u.View(a).initialize(this.element);
              i.signals && i.signals.forEach(function (e) {
                o.addSignalListener(e.name, function () {
                  for (var i = arguments.length, a = Array(i), o = 0; o < i; o++) {
                    a[o] = arguments[o];
                  }

                  var u = r[t.listenerName(e.name)];
                  u && u.apply(n, a);
                });
              }), this.view = o, ["logLevel", "renderer", "tooltip", "background", "width", "height", "padding"].filter(function (e) {
                return s(r[e]);
              }).forEach(function (e) {
                o[e](r[e]);
              });
              var c = this.calculateSize(),
                  l = c.width,
                  p = c.height;
              r.width || (i.width = l, o.width(l)), r.height || (i.height = p, o.height(p)), i.data && r.data && i.data.filter(function (e) {
                return r.data[e.name];
              }).forEach(function (e) {
                n.updateData(e.name, r.data[e.name]);
              }), r.enableHover && o.hover(), o.run(), r.onNewView(o);
            } catch (e) {
              this.clearView(), r.onParseError(e);
            }
          } else this.clearView();

          return this;
        }
      }, {
        key: "updateData",
        value: function value(e, t) {
          t && (c(t) ? t(this.view.data(e)) : this.view.change(e, Object(u.changeset)().remove(function () {
            return !0;
          }).insert(t)));
        }
      }, {
        key: "clearView",
        value: function value() {
          return this.view && (this.view.finalize(), this.removeListeners(), this.view = null), this;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.className,
              i = t.style;
          return r.a.createElement("div", {
            ref: function ref(t) {
              e.element = t;
            },
            className: n,
            style: i
          });
        }
      }], [{
        key: "isSamePadding",
        value: function value(e, t) {
          return s(e) && s(t) ? e.top === t.top && e.left === t.left && e.right === t.right && e.bottom === t.bottom : e === t;
        }
      }, {
        key: "isSameData",
        value: function value(e, t) {
          return e === t && !c(e);
        }
      }, {
        key: "isSameSpec",
        value: function value(e, t) {
          return e === t || JSON.stringify(e) === JSON.stringify(t);
        }
      }, {
        key: "listenerName",
        value: function value(e) {
          return "onSignal" + ((t = e).charAt(0).toUpperCase() + t.slice(1));
          var t;
        }
      }]), t;
    }();

    h.propTypes = p, h.defaultProps = {
      className: "",
      renderer: "svg",
      enableHover: !0,
      onNewView: function onNewView() {},
      onParseError: function onParseError() {}
    };

    var d = h,
        v = n(300),
        m = function m(e) {
      var t = e.width,
          n = e.height,
          i = e.data,
          a = e.spec,
          o = e.theme;
      return r.a.createElement(d, {
        width: t,
        height: n,
        data: i,
        spec: a,
        theme: o || v
      });
    };

    m.propTypes = {
      width: o.a.number,
      height: o.a.number,
      data: o.a.object,
      spec: o.a.object,
      theme: o.a.object
    }, m.defaultProps = {
      width: 200,
      height: 180
    };
    var w = m;
    n.d(t, "VegaChart", function () {
      return d;
    }), n.d(t, "VegaThumbnail", function () {
      return w;
    });
  },
  300: function _(e) {
    e.exports = {
      $schema: "https://vega.github.io/schema/vega/v3.json",
      height: 0,
      padding: "auto",
      render: {
        retina: !0
      },
      axis: {
        domain: !1,
        labels: !1,
        ticks: !1
      }
    };
  },
  53: function _(e, t, n) {
    "use strict";

    var i = n(54);

    function r() {}

    e.exports = function () {
      function e(e, t, n, r, a, o) {
        if (o !== i) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  },
  54: function _(e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }
});